import { Controller } from "@hotwired/stimulus";
import { createElement } from "react";
import { createRoot, type Root } from "react-dom/client";

export default class extends Controller {
  static values = { component: String };

  declare root: Root;
  declare component: string;
  declare readonly componentValue: string;

  connect() {
    import(/* @vite-ignore */ `${this.componentValue}`).then(
      ({ default: Component }) => {
        this.component = Component;
        this.renderComponent();
      },
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  renderComponent() {
    if (this.component) {
      this.root = createRoot(this.element);
      this.root.render(createElement(this.component));
    }
  }
}
